import { t } from '../languages';
const TOKEN_KEY = 'token'

// 获取 token 
export function getToken() {
    return localStorage.getItem(TOKEN_KEY)
}